module.exports = __webpack_public_path__ + "74b52fcaecdbe7ba64bb583fb834adf7.jpg";